import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '$services/auth/auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent {
  error?: string;
  passwordForgotten = false;
  emailSent = false;
  emailError = false;

  @Input() loginForm!: FormGroup

  constructor(private authService: AuthService) {}

  retour() {
    this.passwordForgotten = false;
    this.emailSent = false;
    this.emailError = false;
  }

  sendResetEmail() {
    const email = this.loginForm.get('email')?.value;
    this.authService.sendResetEmail(email).subscribe(
      (response) => {
        this.emailSent = true;
      },
      (error) => {
        this.emailSent = false;
        this.emailError = true;
      }
    );
  }


}
